import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import userReducer from './reducers/user'

import settingsReducer from './reducers/setting'
import infoReducer from './reducers/info'

import trackerReducer from './reducers/mytracker'
import oilPriceReducer from './reducers/oilPrice'

import oilPricesReducer from './reducers/testOilPrice'
import userGroupReducer from './reducers/settings/userGroup'
import flowReducer from './reducers/settings/flow'

import courseTypeReducer from './reducers/settings/courseType'
import courseReducer from './reducers/settings/course'
import courseToJoinReducer from './reducers/course'

import carTypeReducer from './reducers/carReserve/carType'
import carReducer from './reducers/carReserve/car'
import carDriverReducer from './reducers/carReserve/carDriver'


export default combineReducers({
    form: formReducer,
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: userReducer.users,
    user: userReducer.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    info: infoReducer.info,
    settings: settingsReducer.setting,

    master: trackerReducer.master,
    task: trackerReducer.task,
    tasks: trackerReducer.tasks,
    oilprice: oilPriceReducer.oilPrice,

    oilPrices: oilPricesReducer.oilPrices,

    usergroups: userGroupReducer.usergroups,
    usergroup: userGroupReducer.usergroup,

    flows: flowReducer.flows,
    flow: flowReducer.flow,

    courseTypes: courseTypeReducer.courseTypes,
    courseType: courseTypeReducer.courseType,
    courses: courseReducer.courses,
    course: courseReducer.course,

    courseToJoins: courseToJoinReducer.courseToJoins,
    courseToJoin: courseToJoinReducer.courseToJoin,

    carTypes: carTypeReducer.carTypes,
    carType: carTypeReducer.carType,
    masterCarType: carTypeReducer.masterCarType,

    cars: carReducer.cars,
    car: carReducer.car,
    oilType: carReducer.oilType,
    carDriver: carDriverReducer.carDriver



})


// WEBPACK FOOTER //
// ./src/app/redux/reducers.js